import { useQuery } from "react-query";
import axios from "axios";
import { CompanyPensionProduct } from "../types/CompanyPensionProduct";
import useDataStore from "../state/DataStore";
import { TableType } from "../data/TableType";

export default function usePensionProducts(pensionProductTypeId: number) {
  const { setSelectableCompanies, setCompanyPensionProducts } = useDataStore();

  async function fetchProducts(
    pensionProductTypeId: number,
  ): Promise<CompanyPensionProduct[]> {
    const apiURL: string = process.env.REACT_APP_API_DATA_URL || "";

    const response = await axios.get(
      `${apiURL}/pension/product-type/${pensionProductTypeId}`,
    );

    return processPensionProducts(response.data as CompanyPensionProduct[]);
  }

  function processPensionProducts(data: CompanyPensionProduct[]) {
    return data.map((product) => ({
      ...product,
      name: product.securityName
        ? product.securityName
        : product.nameOfCheapestGlobalMutualFundOfferedInTheProduct,
      fundUrl: product.urlOfCheapestGlobalMutualFundOfferedInTheProduct,
    }));
  }

  function extractCompanies(products: CompanyPensionProduct[]) {
    const companies = new Set<string>();
    Object.values(products).forEach((product) =>
      companies.add(product.company.name),
    );

    return companies;
  }

  return useQuery(
    ["pensionProduct", pensionProductTypeId],
    () => fetchProducts(pensionProductTypeId),
    {
      onSuccess: (products) => {
        setCompanyPensionProducts(products);
        setSelectableCompanies(extractCompanies(products), TableType.COMPANIES);
      },
      refetchOnWindowFocus: false,
      retry: 3,
    },
  );
}
